import { render, staticRenderFns } from "./trajectory.vue?vue&type=template&id=4b27af4a&scoped=true&"
import script from "./trajectory.vue?vue&type=script&lang=js&"
export * from "./trajectory.vue?vue&type=script&lang=js&"
import style0 from "./trajectory.vue?vue&type=style&index=0&id=4b27af4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27af4a",
  null
  
)

export default component.exports